import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'titulo-modal',
  templateUrl: './titulo-modal.component.html',
  styleUrls: ['./titulo-modal.component.scss']
})
export class TituloModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
